module.exports = __webpack_public_path__ + "img/2.736797f1.jpg";